import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    location: 'Ciudad de México',
    text: 'Pensé que mi hijo de 4 años tenía TDAH. No se concentraba en nada y gritaba por la tablet. Con el Paso 2 del protocolo, logramos que juegue solo con sus legos por 40 minutos. ¡Es un milagro!',
    rating: 5
  }, {
    name: 'Claudia R.',
    location: 'Bogotá',
    text: "Como mamá que trabaja, las pantallas eran mi salvación y mi maldición. Este ebook me dio la paz que necesitaba sin hacerme sentir culpable. Las estrategias de 'transición' funcionan desde el primer día.",
    rating: 5
  }];
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-147">
      <div className="max-w-5xl mx-auto" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-150">
            Familias que ya recuperaron la paz
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-151"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-152">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-md border border-brand-navy/5 relative" data-id="element-153">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-brand-muted" data-id="element-154" />

              <div className="flex gap-1 mb-6" data-id="element-155">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-156" />)}
              </div>

              <p className="text-lg text-brand-navy/90 leading-relaxed mb-8 italic font-serif" data-id="element-157">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-158">
                <div className="w-12 h-12 bg-brand-teal/10 rounded-full flex items-center justify-center text-brand-teal font-bold text-xl" data-id="element-159">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-160">
                  <p className="font-bold text-brand-navy" data-id="element-161">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-brand-navy/60" data-id="element-162">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}